export default [
  {
    "id": "mat-enem-0984",
    "numero": 2484,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Uma loja vende automóveis em N parcelas \niguais sem juros. No momento de contratar o \nfinanciamento, caso o cliente queira aumentar o \nprazo, acrescentando mais 5 parcelas, o valor \nde cada uma das parcelas diminui R$200,00, ou \nse ele quiser diminuir o prazo, com 4 parcelas a \nmenos, o valor de cada uma das parcelas sobe \nR$ 232,00. Considere ainda que, nas três pos-\nsibilidades de pagamento, o valor do automóvel \né o mesmo, todas são sem juros e não é dado \ndesconto em nenhuma das situações. \n \nNessas condições, qual é a quantidade N de \nparcelas a serem pagas de acordo com a pro-\nposta inicial da loja? \n \nA) 20 \nB) 24 \nC) 29 \nD) 40 \nE) 58",
    "alternativas": {
      "C": "29",
      "D": "40",
      "A": "20",
      "B": "24"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 984,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0986",
    "numero": 2486,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "O salto ornamental é um esporte em que cada \ncompetidor realiza seis saltos. A nota em cada \nsalto é calculada pela soma das notas dos juí-\nzes, multiplicada pela nota de partida (o grau de \ndificuldade de cada salto). Fica em primeiro \nlugar o atleta que obtiver a maior soma das seis \nnotas recebidas. \n \nO atleta 10 irá realizar o último salto da final. Ele \nobserva no Quadro 1, antes de executar o salto, \no recorte do quadro parcial de notas com a sua \nclassificação e a dos três primeiros lugares até \naquele momento. \n \n \n \nEle precisa decidir com seu treinador qual salto \ndeverá realizar. Os dados dos possíveis tipos de \nsalto estão no Quadro 2. \n \n \n \nO atleta optará pelo salto com a maior probabili-\ndade de obter a nota estimada, de maneira que \nlhe permita alcançar o primeiro lugar. \n \nConsiderando essas condições, o salto que o \natleta deverá escolher é o de tipo: \n \nA) T1. \nB) T2. \nC) T3. \nD) T4. \nE) T5.",
    "alternativas": {
      "A": "T1.",
      "C": "T3.",
      "D": "T4.",
      "E": "T5."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 986,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0987",
    "numero": 2487,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Devido ao não cumprimento das metas defini-\ndas para a campanha de vacinação contra a \ngripe comum e o vírus H1N1 em um ano, o Mi-\nnistério da Saúde anunciou a prorrogação da \ncampanha por mais uma semana. A tabela \napresenta as quantidades de pessoas vacina-\ndas dentre os cinco grupos de risco até a data \nde início da prorrogação da campanha. \n \n \n(Disponível em: http://portalsaude.saude.gov.br  \nAcesso em: 16 ago. 2012 - adaptado) \n \nQual é a porcentagem do total de pessoas des-\nses grupos de risco já vacinadas? \n \nA) 12 \nB) 18 \nC) 30 \nD) 40 \nE) 50",
    "alternativas": {
      "A": "12",
      "B": "18",
      "D": "40",
      "E": "50"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 987,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0988",
    "numero": 2488,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um quebra-cabeça consiste em recobrir um \nquadrado com triângulos retângulos isósceles, \ncomo ilustra a figura. \n \n \n \nUma artesã confecciona um quebra-cabeça \ncomo o descrito, de tal modo que a menor das \npeças é um triângulo retângulo isósceles cujos \ncatetos medem 2 cm. \n  \nO quebra-cabeça, quando montado, resultará \nem um quadrado cuja medida do lado, em cen-\ntímetro, é: \n \nA) 14 \nB) 12 \nC) 7√2 \nD) 6 + 4√2 \nE) 6 + 2√2",
    "alternativas": {
      "E": "6 + 2√2",
      "A": "14",
      "B": "12",
      "C": "7√2"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 988,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0989",
    "numero": 2489,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Para decorar um cilindro circular reto será usa-\nda uma faixa retangular de papel transparente, \nna qual está desenhada em negrito uma diago-\nnal que forma 30° com a borda inferior. O raio \nda base do cilindro mede \n6\n𝜋 cm, e ao enrolar a \nfaixa obtém-se uma linha em formato de hélice, \ncomo na figura. \n \n \n \nO valor da medida da altura do cilindro, em cen-\ntímetro, é: \n \nA) 36√3 \nB) 24√3 \nC) 4√3 \nD) 36 \nE) 72",
    "alternativas": {
      "D": "36",
      "A": "36√3",
      "B": "24√3",
      "C": "4√3"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 989,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0990",
    "numero": 2490,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Durante uma festa de colégio, um grupo de \nalunos organizou uma rifa. Oitenta alunos falta-\nram à festa e não participaram da rifa. Entre os \nque compareceram, alguns compraram três \nbilhetes, 45 compraram 2 bilhetes, e muitos \ncompraram apenas um. O total de alunos que \ncomprou um único bilhete era 20% do número \ntotal de bilhetes vendidos, e o total de bilhetes \nvendidos excedeu em 33 o número total de alu-\nnos do colégio. \n \nQuantos alunos compraram somente um bilhe-\nte? \n \nA) 34 \nB) 42 \nC) 47 \nD) 48 \nE) 79",
    "alternativas": {
      "E": "79",
      "B": "42",
      "C": "47",
      "D": "48"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 990,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0992",
    "numero": 2492,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Um torrefador comprou uma saca de 60 kg de \ncafé especial cru (antes de torrar) por R$ \n400,00. Devido à perda de umidade durante o \nprocesso de torrefação, são perdidos 10 kg de \ncafé por saca. \n \nO torrefador irá vender o café torrado em emba-\nlagens de um quilograma e tem por objetivo \nobter um lucro de 200%, em relação ao valor \npago, por unidade vendida. \n \nQue preço de venda, por unidade, este torrefa-\ndor deverá estabelecer para atingir o seu objeti-\nvo? \n \nA) R$ 32,00 \nB) R$ 24,00 \nC) R$ 20,00 \nD) R$ 16,00 \nE) R$ 8,00",
    "alternativas": {
      "D": "R$ 16,00",
      "E": "R$ 8,00",
      "A": "R$ 32,00",
      "B": "R$ 24,00"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 992,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0993",
    "numero": 2493,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "De acordo com a Organização Mundial de Saú-\nde (OMS), o limite de ruído suportável para o \nouvido humano é de 65 decibéis. Ruídos com \nintensidade superior a este valor começam a \nincomodar e causar danos ao ouvido. Em razão \ndisto, toda vez que os ruídos oriundos do pro-\ncesso de fabricação de peças em uma fábrica \nultrapassam este valor, é disparado um alarme \nsonoro, indicando que os funcionários devem \ncolocar proteção nos ouvidos.  \n \nO gráfico fornece a intensidade sonora registra-\nda no último turno de trabalho dessa fábrica. \nNele, a variável t indica o tempo (medido em \nhora), e I indica a intensidade sonora (medida \nem decibel). \n \n \n \nDe acordo com o gráfico, quantas vezes foi \nnecessário colocar a proteção de ouvidos no \núltimo turno de trabalho? \n \nA) 7 \nB) 6 \nC) 4 \nD) 3 \nE) 2",
    "alternativas": {
      "B": "6",
      "C": "4",
      "D": "3",
      "A": "7"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 993,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0994",
    "numero": 2494,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Ao acessar uma página da internet, que trata da \npesquisa de assuntos de interesse juvenil, en-\ncontramos a figura: \n \n \n \nSabe-se que nesse tipo de comunicação visual, \ncomum em páginas da internet, o tamanho das \nletras está diretamente associado ao número de \nvezes que o assunto ou termo foi pesquisado ou \nlido naquela página.  \n \nDessa forma, quanto maior o tamanho das le-\ntras de cada palavra, maior será o número de \nvezes que esse tema foi pesquisado. \n \nDe acordo com a figura, quais são, em ordem \ndecrescente, os três assuntos que mais interes-\nsaram às pessoas que acessaram a página \ncitada? \n \nA) HQ, FÉ, PAZ. \nB) MANGÁS, FÉ, LIVROS. \nC) MÚSICA, BALADAS, AMOR. \nD) AMOR, MÚSICA, BALADAS. \nE) AMOR, BALADAS, MÚSICA.",
    "alternativas": {
      "D": "AMOR, MÚSICA, BALADAS.",
      "E": "AMOR, BALADAS, MÚSICA.",
      "B": "MANGÁS, FÉ, LIVROS.",
      "C": "MÚSICA, BALADAS, AMOR."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 994,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0995",
    "numero": 2495,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Usando a capacidade máxima de carga do ca-\nminhão de uma loja de materiais de construção, \né possível levar 60 sacos de cimento, ou 90 \nsacos de cal, ou 120 latas de areia.  \n \nNo pedido de um cliente, foi solicitada a entrega \nde 15 sacos de cimento, 30 sacos de cal e a \nmaior quantidade de latas de areia que fosse \npossível transportar, atingindo a capacidade \nmáxima de carga do caminhão. \n \nNessas condições, qual a quantidade máxima \nde latas de areia que poderão ser enviadas ao \ncliente? \n \nA) 30 \nB) 40 \nC) 50 \nD) 80 \nE) 90",
    "alternativas": {
      "C": "50",
      "D": "80",
      "E": "90",
      "B": "40"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 995,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0996",
    "numero": 2496,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Uma empresa de construção comprou um terre-\nno de formato retangular por R$ 700.000,00. O \nterreno tem 90 m de comprimento e 240 m de \nlargura. O engenheiro da empresa elaborou três \nprojetos diferentes para serem avaliados pela \ndireção da construção, da seguinte maneira: \n \nProjeto 1: dividir o terreno em lotes iguais de \n45 m x 10 m, sem ruas entre os lotes, e ven-\nder cada lote por R$ 23.000,00; \n \nProjeto 2: dividir o terreno em lotes iguais de \n20 m x 30 m, deixando entre lotes ruas de 10 \nm de largura e 240 m de comprimento, e \nvender cada lote por R$ 35.000,00; \n \nProjeto 3: dividir o terreno em lotes iguais de \n35 m x 20 m, deixando entre lotes ruas de 20 \nm de largura e 240 m de comprimento, e \nvender cada lote por R$ 45.000,00. \n \nA direção da empresa decidiu dividir o terreno e \nutilizar o projeto que permitirá o maior lucro, \nsendo que este será igual ao valor obtido pela \nvenda dos lotes, menos o valor da compra do \nterreno. \n \nNesse caso, o lucro da construtora, em real, \nserá de: \n \nA) 380.000,00 \nB) 404.000,00 \nC) 1.104.000,00 \nD) 1.120.000,00 \nE) 1.460.000,00",
    "alternativas": {
      "D": "1.120.000,00",
      "E": "1.460.000,00",
      "A": "380.000,00",
      "B": "404.000,00"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 996,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0997",
    "numero": 2497,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "A inclinação de um telhado depende do tipo e \nda marca das telhas escolhidas. A figura é o \nesboço do telhado da casa de um específico \nproprietário. As telhas serão apoiadas sobre a \nsuperfície quadrada plana ABCD, sendo BOC \num triângulo retângulo em O. Sabe-se que h é a \naltura do telhado em relação ao forro da casa (a \nfigura plana ABOE), b = 10 é o comprimento do \nsegmento OB, e d é a largura do telhado (seg-\nmento AB), todas as medidas dadas em metro. \n \n \n \n(Disponível em: www.toptelha.com.br.  \nAcesso em: 31 jul. 2012) \nSabe-se que, em função do tipo de telha esco-\nlhida pelo proprietário, a porcentagem i de incli-\nnação ideal do telhado, descrita por meio da \nrelação i = \nℎ 𝑥 100\n𝑏\n, é de 40%, e que a expres-\nsão que determina o número N de telhas neces-\nsárias na cobertura é dada por N = d2 x 10,5. \nAlém disso, essas telhas são vendidas somente \nem milheiros. \n \nO proprietário avalia ser fundamental respeitar a \ninclinação ideal informada pelo fabricante, por \nisso argumenta ser necessário adquirir a quan-\ntidade mínima de telhas correspondente a: \n \nA) um milheiro. \nB) dois milheiros. \nC) três milheiros. \nD) seis milheiros. \nE) oito milheiros.",
    "alternativas": {
      "E": "oito milheiros.",
      "A": "um milheiro.",
      "B": "dois milheiros.",
      "D": "seis milheiros."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 997,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0998",
    "numero": 2498,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Dois amigos abriram um restaurante. No primei-\nro ano, o custo total com as despesas do res-\ntaurante chegou a 250 mil reais. A receita neste \nano foi de 325 mil reais, obtendo assim um lucro \nde 75 mil reais (diferença entre a receita e o \ncusto total). A tabela representa o custo total e a \nreceita nos cinco primeiros anos. \n \n \n \nDe acordo com a tabela, a média anual do lucro, \nem milhar de real, ao longo dos cinco anos é: \n \nA) 60. \nB) 70. \nC) 75. \nD) 80. \nE) 85.",
    "alternativas": {
      "A": "60.",
      "B": "70.",
      "C": "75.",
      "E": "85."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 998,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0999",
    "numero": 2499,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Uma pessoa tem massa corporal de 167 kg. \nSob orientação de um nutricionista, submeteu-\nse a um regime alimentar, em que se projeta \nque a perda de quilos mensais seja inferior a 5 \nkg. Após iniciar o regime, observou-se, nos três \nprimeiros meses, uma perda de 4 kg por mês, e \nnos quatro meses seguintes, uma perda mensal \nde 3 kg. \nDaí em diante, segundo as recomendações do \nnutricionista, deveria haver uma perda mensal \nfixa em cada um dos meses subsequentes, \nobjetivando alcançar a massa corporal de 71 kg \nao final do regime. \n \nSegundo as projeções e recomendações do \nnutricionista, para alcançar seu objetivo, a dura-\nção mínima, em mês, que essa pessoa deverá \nmanter o seu regime será de: \n \nA) 15. \nB) 20. \nC) 21. \nD) 22. \nE) 25.",
    "alternativas": {
      "D": "22.",
      "A": "15.",
      "B": "20.",
      "C": "21."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 999,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1000",
    "numero": 2500,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Em 2012, o PNUD Brasil, o Ipea e a Fundação \nJoão Pinheiro assumiram o desafio de adaptar a \nmetodologia do Índice de Desenvolvimento Hu-\nmano (IDH) global para calcular o Índice de \nDesenvolvimento Humano Municipal (IDHM) \ndos 5.565 municípios brasileiros com base nos \ndados do Censo Demográfico de 2010. Tam-\nbém se recalculou o IDHM, pela metodologia \nadotada, para os anos de 1990 e 2000, para \npermitir a comparabilidade temporal e espacial \nentre os municípios. \n \nNo quadro são apresentados os dados de cinco \ncidades brasileiras. \n \n \n \n(Disponível em: http://atlasbrasil.org.br.  \nAcesso em: 26 abr. - adaptado) \n \nUma ONG decide fazer um trabalho de acom-\npanhamento com a cidade que teve a menor \nmédia aritmética dos IDHM das três últimas \ndécadas dentre as cinco cidades analisadas. \n \nCom base nos dados fornecidos, qual foi o mu-\nnicípio escolhido pela ONG? \n \nA) Florianópolis. \nB) Águas de São Pedro. \nC) Balneário Camboriú. \nD) São Caetano do Sul. \nE) Vitória.",
    "alternativas": {
      "E": "Vitória.",
      "A": "Florianópolis.",
      "C": "Balneário Camboriú.",
      "D": "São Caetano do Sul."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1000,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1001",
    "numero": 2501,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "A quantidade x de peças, em milhar, produzidas \ne o faturamento y, em milhar de real, de uma \nempresa estão representados nos gráficos, \nambos em função do número t de horas traba-\nlhadas por seus funcionários. \n \n \n \n \n \nO número de peças que devem ser produzidas \npara se obter um faturamento de R$ 10 000,00 \né: \n \nA) 2.000. \nB) 2.500. \nC) 40.000. \nD) 50.000. \nE) 200.000.",
    "alternativas": {
      "D": "50.000.",
      "E": "200.000.",
      "A": "2.000.",
      "C": "40.000."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1001,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1002",
    "numero": 2502,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Na intenção de ampliar suas fatias de mercado, as operadoras de telefonia apresentam diferentes planos \ne promoções. Uma operadora oferece três diferentes planos baseados na quantidade de minutos utiliza-\ndos mensalmente, apresentados no gráfico. Um casal foi à loja dessa operadora para comprar dois celu-\nlares, um para a esposa e outro para o marido. Ela utiliza o telefone, em média, 30 minutos por mês, \nenquanto ele, em média, utiliza 90 minutos por mês. \n \n \n \nCom base nas informações do gráfico, qual é o plano de menor custo mensal para cada um deles? \n \nA) O plano A para ambos. \nB) O plano B para ambos. \nC) O plano C para ambos. \nD) O plano B para a esposa e o plano C para o marido. \nE) O plano C para a esposa e o plano B para o marido.",
    "alternativas": {
      "D": "O plano B para a esposa e o plano C para o marido.",
      "E": "O plano C para a esposa e o plano B para o marido.",
      "A": "O plano A para ambos.",
      "B": "O plano B para ambos."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1002,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1003",
    "numero": 2503,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "No quadro estão representados as quantidades de certos tipos de vinho vendidos durante um ano e o \nlucro por unidade vendida de cada um desses tipos. Para repor seu estoque, o proprietário escolherá \napenas os tipos de vinho em que o lucro total com sua venda foi maior do que a média entre os lucros \nobtidos com a venda de todos os tipos. \n \n \n \nConforme condições estabelecidas, os tipos de vinho escolhidos serão: \n \nA) I e VI. \nB) IV e VI. \nC) I, IV e VI. \nD) II, IV e VI. \nE) II, III, IV e VI.",
    "alternativas": {
      "B": "IV e VI.",
      "C": "I, IV e VI.",
      "E": "II, III, IV e VI.",
      "A": "I e VI."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1003,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1005",
    "numero": 2505,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "A Lei da Gravitação, de Isaac Newton, estabe-\nlece a intensidade da força entre dois objetos. \nEla é dada pela equação F = g \n𝑚1 𝑚2\n𝑑2\n, sendo m1 \ne m2 as massas dos objetos, d a distância entre \neles, g a constante universal da gravitação e F a \nintensidade da força gravitacional que um objeto \nexerce sobre o outro. \nConsidere um esquema que represente cinco \nsatélites de mesma massa orbitando a Terra. \nDenote os satélites por A, B, C, D e E, sendo \nesta a ordem decrescente da distância da Terra \n(A o mais distante e E o mais próximo da Terra). \n \nDe acordo com a Lei de Gravitação Universal, a \nTerra exerce maior força sobre o satélite: \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "C": "C.",
      "D": "D.",
      "E": "E.",
      "B": "B."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1005,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1006",
    "numero": 2506,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Uma pessoa possui um terreno em forma de um \npentágono, como ilustrado na figura. \n \n \n \nSabe-se que a diagonal AD mede 50 m e é pa-\nralela ao lado BC, que mede 29 m. A distância \ndo ponto B a AD é de 8 m e a distância do ponto \nE a AD é de 20 m. \n \nA área, em metro quadrado, deste terreno é \nigual a: \n \nA) 658. \nB) 700. \nC) 816. \nD) 1.132 \nE) 1.632",
    "alternativas": {
      "A": "658.",
      "C": "816.",
      "D": "1.132",
      "E": "1.632"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1006,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1007",
    "numero": 2507,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Para pintar um automóvel, cuja cor é personali-\nzada, a oficina encarregada de fazer o serviço \nterá de, por meio de uma mistura adequada de \ntintas, compor tons de azul e de branco. O tom \nazul representa 40% dessa mistura. \n    \nSabe-se, ainda, que a oficina deverá adquirir \nsomente a tinta de tom azul, pois já possui, em \nseus estoques, 6 litros da tinta de tom branco, \nque serão totalmente utilizados na referida \ncomposição. \nA quantidade, em litro, de tinta de tom azul que \na oficina deverá adquirir para compor essa mis-\ntura, sem que haja sobras, é: \n \nA) 2,4. \nB) 3,6. \nC) 4,0. \nD) 9,0. \nE) 10,0.",
    "alternativas": {
      "A": "2,4.",
      "B": "3,6.",
      "C": "4,0.",
      "E": "10,0."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1007,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1008",
    "numero": 2508,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Alguns modelos de rádios automotivos estão \nprotegidos por um código de segurança. Para \nativar o sistema de áudio, deve-se digitar o có-\ndigo secreto composto por quatro algarismos. \nNo primeiro caso de erro na digitação, a pessoa \ndeve esperar 60 segundos para digitar o código \nnovamente. O tempo de espera duplica, em \nrelação ao tempo de espera anterior, a cada \ndigitação errada. Uma pessoa conseguiu ativar \no rádio somente na quarta tentativa, sendo de \n30 segundos o tempo gasto para digitação do \ncódigo secreto a cada tentativa. Nos casos da \ndigitação incorreta, ela iniciou a nova tentativa \nimediatamente após a liberação do sistema de \nespera. \n \nO tempo total, em segundo, gasto por essa pes-\nsoa para ativar o rádio foi igual a: \n \nA) 300. \nB) 420. \nC) 540. \nD) 660. \nE) 1.020.",
    "alternativas": {
      "B": "420.",
      "C": "540.",
      "E": "1.020.",
      "A": "300."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1008,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1009",
    "numero": 2509,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Uma fábrica comercializa chocolates em uma \ncaixa de madeira, como na figura. \n \n \n \nA caixa de madeira tem a forma de um parale-\nlepípedo reto-retângulo cujas dimensões exter-\nnas, em centímetros, estão indicadas na figura. \nSabe-se também que a espessura da madeira, \nem todas as suas faces, é de 0,5 cm. \nQual é o volume de madeira utilizado, em cen-\ntímetro cúbico, na construção de uma caixa de \nmadeira como a descrita para embalar os cho-\ncolates? \n \nA) 654 \nB) 666 \nC) 673 \nD) 681 \nE) 693",
    "alternativas": {
      "C": "673",
      "D": "681",
      "A": "654",
      "B": "666"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1009,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1010",
    "numero": 2510,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "As Artes Marciais Mistas, tradução do inglês: \nMMA – mixed martial arts, são realizadas num \noctógono regular. De acordo com a figura, em \ncerto momento os dois lutadores estão respecti-\nvamente nas posições G e F, e o juiz está na \nposição I. O triângulo IGH é equilátero e GÎF é o \nângulo formado pelas semirretas com origem na \nposição do juiz, respectivamente passando pe-\nlas posições de cada um dos lutadores. \n \n \n \nA medida do ângulo GÎF é: \n \nA) 120° \nB) 75° \nC) 67,5° \nD) 60° \nE) 52,5°",
    "alternativas": {
      "D": "60°",
      "E": "52,5°",
      "B": "75°",
      "C": "67,5°"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1010,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1011",
    "numero": 2511,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Um rapaz possui um carro usado e deseja utili-\nzá-lo como parte do pagamento na compra de \num carro novo. Ele sabe que, mesmo assim, \nterá que financiar parte do valor da compra. \n \nDepois de escolher o modelo desejado, o rapaz \nfaz uma pesquisa sobre as condições de com-\npra em três lojas diferentes. Em cada uma, é \ninformado sobre o valor que a loja pagaria por \nseu carro usado, no caso de a compra ser feita \nna própria loja. Nas três lojas são cobrados \njuros simples sobre o valor a ser financiado, e a \nduração do financiamento é de um ano. O rapaz \nescolherá a loja em que o total, em real, a ser \ndesembolsado será menor. \nO quadro resume o resultado da pesquisa. \n \n \n \nA quantia a ser desembolsada pelo rapaz, em \nreal, será: \n \nA) 14.000. \nB) 15.000. \nC) 16.800. \nD) 17.255. \nE) 17.700.",
    "alternativas": {
      "C": "16.800.",
      "D": "17.255.",
      "E": "17.700.",
      "A": "14.000."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1011,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1012",
    "numero": 2512,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "No final de uma matéria sobre sorte e azar pu-\nblicada em uma revista, o leitor tem a opção de \nrealizar um teste no qual ele deve responder a \ndez perguntas sobre cinco temas, sendo cinco \nsobre sorte e cinco sobre azar. Para cada per-\ngunta, o leitor marca apenas uma alternativa \ndentre as seis opções de respostas, sendo que \na alternativa escolhida está associada a uma \nnota entre os valores 1, 3, 5, 7, 8 e 9. \n   \nUm leitor respondeu ao teste, obtendo as notas \nde sorte e de azar para as perguntas e repre-\nsentou-as no Quadro 1. \n \n \n \nO resultado do teste x é calculado como sendo \na diferença entre as médias aritméticas das \nnotas de sorte e de azar, nessa ordem. A classi-\nficação desse resultado é dada de acordo com o \nQuadro 2. \n \n \n \n(SANTI,A.; KIST, C. Sorte: manual de instruções. \nSuperinteressante. ago. 2012 - adaptado) \n \nDe acordo com os dados apresentados, a clas-\nsificação do resultado do teste desse leitor é: \n \nA) “Você é azarado”. \nB) “Você é sortudo”. \nC) “Você é muito azarado”. \nD) “Você é muito sortudo”. \nE) “Você está na média”.",
    "alternativas": {
      "A": "“Você é azarado”.",
      "B": "“Você é sortudo”.",
      "D": "“Você é muito sortudo”.",
      "E": "“Você está na média”."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1012,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1013",
    "numero": 2513,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Para garantir segurança ao dirigir, alguns moto-\nristas instalam dispositivos em seus carros que \nalertam quando uma certa velocidade máxima \n(Vmáx), pré-programada pelo usuário de acordo \ncom a velocidade máxima da via de tráfego, é \nultrapassada. O gráfico exibido pelo dispositivo \nno painel do carro após o final de uma viagem \nfornece a velocidade (km/h) do carro em função \ndo tempo (h). \n \n \n \nDe acordo com o gráfico, quantas vezes o dis-\npositivo alertou o motorista no percurso da via-\ngem? \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "E": "5",
      "A": "1",
      "B": "2",
      "C": "3"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1013,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1014",
    "numero": 2514,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "O presidente de uma empresa, com o objetivo \nde renovar sua frota de automóveis, solicitou \numa pesquisa medindo o consumo de combus-\ntível de 5 modelos de carro que usam o mesmo \ntipo de combustível. O resultado foi: \n \n• Carro I: deslocamento de 195 km consumindo \n20 litros de combustível. \n \n• Carro II: deslocamento de 96 km consumindo \n12 litros de combustível. \n \n• Carro III: deslocamento de 145 km consumin-\ndo 16 litros de combustível. \n• Carro IV: deslocamento de 225 km consumin-\ndo 24 litros de combustível. \n \n• Carro V: deslocamento de 65 km consumindo \n8 litros de combustível. \n \nPara renovar a frota com o modelo mais eco-\nnômico, em relação à razão quilômetro rodado \npor litro, devem ser comprados carros do mode-\nlo: \n \nA) I. \nB) II. \nC) II. \nD) IV. \nE) V.",
    "alternativas": {
      "B": "II.",
      "C": "II.",
      "D": "IV.",
      "A": "I."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1014,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1015",
    "numero": 2515,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Uma empresa especializada em embalagem de \npapelão recebeu uma encomenda para fabricar \ncaixas para um determinado modelo de televi-\nsor, como o da figura. \n \n \n \nA embalagem deve deixar uma folga de 5 cm \nem cada uma das dimensões. Esta folga será \nutilizada para proteger a televisão com isopor. O \npapelão utilizado na confecção das caixas pos-\nsui uma espessura de 0,5 cm. \n \nA empresa possui 5 protótipos de caixa de pa-\npelão, na forma de um paralelepípedo reto-\nretângulo, cujas medidas externas: comprimen-\nto, altura e largura, em centímetro, são respecti-\nvamente iguais a: \n \nCaixa 1: 68,0 × 50,0 × 18,5 \nCaixa 2: 68,5 × 50,5 × 19,0 \nCaixa 3: 72,5 × 54,5 × 23,0 \nCaixa 4: 73,0 × 55,0 × 23,5 \nCaixa 5: 73,5 × 55,5 × 24,0 \n \nO modelo de caixa de papelão que atende exa-\ntamente as medidas das dimensões especifica-\ndas é a: \n \nA) caixa 1. \nB) caixa 2. \nC) caixa 3. \nD) caixa 4. \nE) caixa 5.",
    "alternativas": {
      "E": "caixa 5.",
      "B": "caixa 2.",
      "C": "caixa 3.",
      "D": "caixa 4."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1015,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1016",
    "numero": 2516,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "O quadro apresenta os dados da pescaria de \numa espécie de peixe realizada ao final de um \ndia de pesca, em lagos diferentes. \n \n \nConsidere que a medida do esforço de pesca \n(E) seja dada pela função E = 2 ⋅ 10–7 ⋅ B ⋅ H.      \nA captura (quantidade pescada C) e a popula-\nção de peixes P(L) dessa espécie no lago L, no \ninício desse dia de pescaria, relacionam-se pela \nfórmula C = E⋅ P(L). \n \nEm qual lago a população de peixes dessa es-\npécie era maior no início do dia? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "C": "III",
      "D": "IV",
      "E": "V",
      "A": "I"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1016,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1017",
    "numero": 2517,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Em uma corrida de dez voltas disputada por \ndois carros antigos, A e B, o carro A completou \nas dez voltas antes que o carro B completasse a \noitava volta. Sabe-se que durante toda a corrida \nos dois carros mantiveram velocidades constan-\ntes iguais a 18 m/s e 14 m/s. Sabe-se também \nque o carro B gastaria 288 segundos para com-\npletar oito voltas. \n \nA distância, em metro, que o carro B percorreu \ndo início da corrida até o momento em que o \ncarro A completou a décima volta foi mais pró-\nxima de: \n \nA) 6.480. \nB) 5.184. \nC) 5.040. \nD) 4.032. \nE) 3.920.",
    "alternativas": {
      "B": "5.184.",
      "D": "4.032.",
      "E": "3.920.",
      "A": "6.480."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1017,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1018",
    "numero": 2518,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Visando atingir metas econômicas previamente \nestabelecidas, é comum no final do mês algu-\nmas lojas colocarem certos produtos em promo-\nção. Uma determinada loja de departamentos \ncolocou em oferta os seguintes produtos: televi-\nsão, sofá e estante. Na compra da televisão \nmais o sofá, o cliente pagaria R$ 3.800,00. Se \nele levasse o sofá mais a estante, pagaria R$ \n3.400,00. A televisão mais a estante sairiam por \nR$ 4.200,00. Um cliente resolveu levar duas \ntelevisões e um sofá que estavam na promoção, \nconseguindo ainda mais 5% de desconto pelo \npagamento à vista. \n \nO valor total, em real, pago pelo cliente foi de: \n \nA) 3.610,00. \nB) 5.035,00. \nC) 5.415,00. \nD) 5.795,00. \nE) 6.100,00.",
    "alternativas": {
      "C": "5.415,00.",
      "D": "5.795,00.",
      "A": "3.610,00.",
      "B": "5.035,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1018,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1020",
    "numero": 2520,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Um vaso decorativo quebrou e os donos vão \nencomendar outro para ser pintado com as \nmesmas características. Eles enviam uma foto \ndo vaso na escala 1 : 5 (em relação ao objeto \noriginal) para um artista. Para ver melhor os \ndetalhes do vaso o artista solicita uma cópia \nimpressa da foto com dimensões triplicadas em \nrelação ás dimensões da foto original. Na cópia \nimpressa, o vaso quebrado tem uma altura de \n30 centímetros. \n \nQual é a altura real, em centímetros, do vaso \nquebrado? \n \nA) 2 \nB) 18 \nC) 50 \nD) 60 \nE) 90",
    "alternativas": {
      "D": "60",
      "E": "90",
      "B": "18",
      "C": "50"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1020,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1021",
    "numero": 2521,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Um projétil é lançado por um canhão e atinge o \nsolo a uma distância de 150 metros do ponto de \npartida. Ele percorre uma trajetória parabólica, e \na altura máxima que atinge em relação ao solo \né de 25 metros. \n \n \n \nAdmita um sistema de coordenadas xy em que \nno eixo vertical y está representada a altura e \nno eixo horizontal x está representada a distân-\ncia, ambas em metro. Considere que o canhão \nestá no ponto (150; 0) e que o projétil atinge o \nsolo no ponto (0; 0) do plano xy. \n \nA equação da parábola que representa a trajetó-\nria descrita pelo projétil é: \n \nA) y = 150x – x² \nB) y = 3.750x – 25x² \nC) 75y = 300x – 2x² \nD) 125y = 450x – 3x² \nE) 225y = 150x – x²",
    "alternativas": {
      "C": "75y = 300x – 2x²",
      "D": "125y = 450x – 3x²",
      "E": "225y = 150x – x²",
      "A": "y = 150x – x²"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1021,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1022",
    "numero": 2522,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Uma senhora acaba de fazer uma ultrassono-\ngrafia e descobre que está grávida de quadri-\ngêmeos. \n \nQual é a probabilidade de nascerem dois meni-\nnos e duas meninas? \n \nA) 1/16 \nB) 3/16 \nC) 1/4 \nD) 3/8 \nE) 1/2",
    "alternativas": {
      "E": "1/2",
      "A": "1/16",
      "B": "3/16",
      "D": "3/8"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1022,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1023",
    "numero": 2523,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "O índice de massa corporal (IMC) de uma pessoa é definido como o quociente entre a massa dessa \npessoa, medida em quilograma, e o quadrado da sua altura, medida em metro. Esse índice é usado co-\nmo parâmetro para verificar se o indivíduo está o não acima do peso ideal para a sua altura. Durante o \nano de 2011, uma pessoa foi acompanhada por um nutricionista e passou por um processo de reeduca-\nção alimentar. O gráfico indica a variação mensal do IMC dessa pessoa, durante o nutricionista vai anali-\nsar as medidas estatísticas referentes à variação do IMC. \n \n \n \nDe acordo com o gráfico, podemos concluir que a mediana da variação mensal do IMC dessa pessoa é \nigual a: \n \nA) 27,40 \nB) 27,55 \nC) 27,70 \nD) 28,15 \nE) 28,45",
    "alternativas": {
      "C": "27,70",
      "E": "28,45",
      "A": "27,40",
      "B": "27,55"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1023,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1024",
    "numero": 2524,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "A figura a seguir representa parte da planta de um loteamento, em que foi usada a escala 1 : 1 000. No \ncentro da planta uma área circular, com diâmetro de 8 cm, foi destinada para a construção de uma pra-\nça. \n \n \nO diâmetro real dessa praça, em metro, é: \n \nA) 1.250 \nB) 800 \nC) 125 \nD) 80 \nE) 8",
    "alternativas": {
      "A": "1.250",
      "B": "800",
      "C": "125",
      "D": "80"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1024,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1026",
    "numero": 2526,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Em certa página de um livro foi anotada uma senha. Para se descobrir qual é a página, dispõe da infor-\nmação de que a soma dos quadrados dos três números correspondentes à página da senha, à página \nanterior e à página posterior é igual a um certo número k que será informado posteriormente. \n \nDenotando por n o número da página da senha, qual é a expressão que relaciona n e k? \n \nA) 3n² – 4n = k – 2 \nB) 3n² + 4n = k – 2 \nC) 3n² = k + 2 \nD) 3n² = k – 2 \nE) 3n² = k",
    "alternativas": {
      "E": "3n² = k",
      "A": "3n² – 4n = k – 2",
      "C": "3n² = k + 2",
      "D": "3n² = k – 2"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1026,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1027",
    "numero": 2527,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Um comerciante abrirá um supermercado, no \nmês de outubro, e precisa distribuir 5 produtos \nde limpeza em uma gôndola de cinco prateleiras \nque estão dispostas uma acima da outra (um \ntipo de produto por prateleira). Ele sabe que a \nterceira prateleira oferece uma melhor visibilida-\nde dos produtos aos clientes. \n \nEle fez uma pesquisa sobre o número de ven-\ndas desses produtos, nos meses de agosto e \nsetembro, em uma loja da concorrência (mos-\ntrada a seguir), e pretende incrementar suas \nvendas, em relação a seu concorrente, colocan-\ndo na terceira prateleira de seu supermercado o \nproduto que teve o maior índice de aumento nas \nvendas no mês de setembro em relação ao mês \nde agosto, na loja concorrente. \n \n \n \nO comerciante deve colocar na terceira pratelei-\nra o produto número: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "B": "II.",
      "D": "IV.",
      "E": "V.",
      "A": "I."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1027,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1028",
    "numero": 2528,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Um brinquedo chamado pula-pula, quando visto \nde cima, consiste de uma cama elástica com \ncontorno em formato de um hexágono regular. \n \n \n \nSe a área do círculo inscrito no hexágono é       \n3 metros quadrados, então a área do hexágono, \nem metro quadrado, é: \n \nA) 9 \nB) 63√3 \nC) 92√2 \nD) 12 \nE) 123√3",
    "alternativas": {
      "C": "92√2",
      "E": "123√3",
      "A": "9",
      "B": "63√3"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1028,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];